// FRAMEWORK
import React, { useContext } from 'react'
import { Link } from 'gatsby'

// BOOTSTRAP
import Container from 'react-bootstrap/Container'
import Navbar from 'react-bootstrap/Navbar'
import Stack from 'react-bootstrap/Stack'

// APP
import Bag from './bag'
import Cart from './cart'
import Nav from './nav'
import NavSearch from '../algolia/nav-search'
import AppContext from '../context/app'

// SVGS
import logo from '../images/svgs/air-logo-white.svg'
import menu from '../images/svgs/toggler-icon-white.svg'

export default function Naviagtion() {
    const { setShowNav } = useContext(AppContext)

    return (
        <Navbar sticky='top' expand={false} className='p-0' style={{ zIndex: 2 }}>
            <Container fluid style={{ background: 'black', zIndex: 2 }} className='position-relative'>
                <Container className='d-flex align-items-center justify-content-md-between justify-content-end' style={{ paddingTop: 9, paddingBottom: 9 }}>
                    {/* DESKTOP SEARCH BAR */}
                    <NavSearch className='d-none d-md-flex' />
                    
                    {/* PERFECT CENTER */}
                    <Navbar.Brand className='position-absolute top-50 start-50 translate-middle p-0 m-0'>
                        <Link to='/'>
                            <img src={logo} alt='' />
                        </Link>
                    </Navbar.Brand>
                    
                    <Stack direction='horizontal' className='align-items-center' gap={4}>
                        <Bag />

                        {/* HAMBURGER */}
                        <Navbar.Toggle onClick={() => setShowNav(true)} className='p-0 border-0'>
                            <img src={menu} alt='' />
                        </Navbar.Toggle>
                    </Stack>
                </Container>
            </Container>
            
            <Nav />
            <Cart />
        </Navbar>
    )
}
